import { AxiosPromise } from 'axios';

import { reportsInstance } from './config';
import { res } from './utils';

const getReports = (): AxiosPromise => reportsInstance.get('').then(res);

export default {
  getReports,
};
